// extracted by mini-css-extract-plugin
export var footer = "br11-u";
export var footerBottom = "br11-H";
export var footerNavItem = "br11-G";
export var footerNavs = "br11-F";
export var footerTop = "br11-v";
export var footerTopQrcode = "br11-w";
export var footerTopQrcodeBox = "br11-x";
export var footerTopQrcodeBoxImg = "br11-y";
export var footerTopQrcodeText = "br11-z";
export var footerTopQrcodeTextHighlight = "br11-A";
export var footerTopRight = "br11-B";
export var footerTopRightAddress = "br11-E";
export var footerTopRightDescription = "br11-D";
export var footerTopRightLogo = "br11-C";